import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Wallet } from "lucide-react";
import api from "@/lib/api";
import { money, fmtDate, fmtTimeRange } from "@/lib/format";
import UnifiedPaymentModal from "@/components/pos/UnifiedPaymentModal";

// Live outstanding balances for this center (or the enhancer's own clients).
export default function POSOutstanding() {
  const [f, setF] = useState({ dfrom: "", dto: "", enhancer_id: "", q: "" });
  const [pay, setPay] = useState(null);
  const qs = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
  const { data, isLoading } = useQuery({ queryKey: ["pos-u-outstanding", qs], queryFn: () => api.get(`/pos/u/outstanding?${qs}`).then((r) => r.data), refetchInterval: 15000 });
  const rows = data?.rows || [];
  return (
    <div data-testid="pos-outstanding">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-serif text-2xl text-[#1A242B]">Outstanding balances</h2>
          <p className="text-sm text-[#4A5D6B]">Click any row to take a payment. Paid balances drop off automatically.</p>
        </div>
        <p className="font-serif text-xl text-[#B5794E]" data-testid="pos-outstanding-total">{money(data?.total || 0)} open</p>
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        <input type="date" value={f.dfrom} onChange={(e) => setF({ ...f, dfrom: e.target.value })} data-testid="pos-outstanding-from" className="eyw-input !py-2 text-sm" />
        <input type="date" value={f.dto} onChange={(e) => setF({ ...f, dto: e.target.value })} data-testid="pos-outstanding-to" className="eyw-input !py-2 text-sm" />
        <select value={f.enhancer_id} onChange={(e) => setF({ ...f, enhancer_id: e.target.value })} data-testid="pos-outstanding-enhancer" className="eyw-input !py-2 text-sm">
          <option value="">All enhancers</option>
          {(data?.enhancers || []).map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
        </select>
        <input value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="Search client or offering" data-testid="pos-outstanding-search" className="eyw-input !py-2 text-sm flex-1 min-w-[200px]" />
      </div>
      {isLoading ? <Loader2 className="animate-spin mt-8 text-[#144F75]" /> : rows.length === 0 ? (
        <p className="eyw-card p-8 mt-5 text-center text-[#4A5D6B]" data-testid="pos-outstanding-empty">Everything is settled. No outstanding balances right now.</p>
      ) : (
        <div className="eyw-card mt-5 overflow-x-auto"><table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-[#8FA89B] bg-[#F9F7F3]"><th className="py-2.5 px-4">Date</th><th>Booking</th><th>Client</th><th>Enhancer</th><th className="text-right">Paid</th><th className="text-right px-4">Due</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={`${r.kind}-${r.id}`} onClick={() => setPay(r)} data-testid={`pos-outstanding-row-${r.id}`} className="border-t border-[#E5E0D8] cursor-pointer hover:bg-[#144F75]/[0.03]">
              <td className="py-2.5 px-4 whitespace-nowrap">{fmtDate(r.date)}<span className="block text-[11px] text-[#8FA89B]">{fmtTimeRange(r.time)}</span></td>
              <td>{r.title}<span className="block text-[11px] text-[#8FA89B]">{r.kind === "booking" ? "Appointment" : "Event"} · {(r.payment_status || "unpaid").replace("_", " ")}</span></td>
              <td>{r.customer_name || r.customer_email}</td><td className="text-xs">{r.enhancer_name || "—"}</td>
              <td className="text-right">{money(r.amount_paid)}</td>
              <td className="text-right px-4 font-semibold text-[#B5794E]"><span className="inline-flex items-center gap-1"><Wallet size={12} />{money(r.balance_due)}</span></td>
            </tr>))}</tbody>
        </table></div>
      )}
      {pay && <UnifiedPaymentModal kind={pay.kind} refId={pay.id} onClose={() => setPay(null)} />}
    </div>
  );
}
